/* Blunder Club: quiet scroll reveal and image fade-in. Opacity only; respects reduced motion. */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const root = document.documentElement;
  root.classList.add('js-motion');
  const loaded = img => img.classList.add('is-loaded');
  const watchImages = scope => scope.querySelectorAll('img[loading=lazy]').forEach(img => {
    if (img.complete && img.naturalWidth) loaded(img);
    else { img.addEventListener('load', () => loaded(img), { once: true }); img.addEventListener('error', () => loaded(img), { once: true }); }
  });
  const io = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  const mark = () => {
    document.querySelectorAll('.product-grid, .product-rail').forEach(grid => {
      [...grid.children].forEach((card, i) => {
        if (card.hasAttribute('data-reveal')) return;
        card.setAttribute('data-reveal', '');
        card.style.setProperty('--reveal-delay', Math.min(i % 4, 3) * 60 + 'ms');
        io.observe(card);
      });
    });
    watchImages(document.getElementById('MainContent') || document);
  };
  const start = () => {
    mark();
    requestAnimationFrame(() => document.querySelectorAll('[data-reveal]').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in');
    }));
    new MutationObserver(mark).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    setTimeout(() => document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }), 1500);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
